export default "__VITE_ASSET__C4sQPfx0__"